import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import breakpoints from '../../utilities/breakpoints';
import { FooterGlobalStyle } from '../GlobalStyles';
import NotificationGlobalStyle from '../porsche/notification/NotificationGlobalStyle';
import themeTokens from './themeTokens';

export const PORSCHE_V3_THEME_CLASSNAME = 'theme-porsche-v3';

const GlobalThemeToken = createGlobalStyle`
    html.${PORSCHE_V3_THEME_CLASSNAME} {
        /* For css variables antd override */
        --ant-primary-color: ${themeTokens.primaryColor};
        --ant-primary-color-hover: ${themeTokens.hoveredPrimaryColor};
        --ant-primary-color-active: ${themeTokens.primaryColor};

        --font-family: ${themeTokens.fontFamily};

        /* font sizes */
        --button-font-size: ${themeTokens.buttonFontSize};
        --input-font-size: ${themeTokens.inputFontSize};

        /* input field */
        --input-height: ${themeTokens.inputFieldHeight};

        /* checkboxes */
        --checkbox-width: 1.5rem;
        --checkbox-height: 1.5rem;

        --checkbox-inner-border-color: #ffffff;
        --checkbox-inner-background-color: #626669;

        --checkbox-summary-checked-inner-border-color: #323639;
        --checkbox-checked-inner-border-color: #323639;
        --checkbox-summary-checked-inner-background-color: #323639;
        --checkbox-checked-inner-background-color: #323639;

        --checkbox-checked-inner-after-border-color: #ffffff;

        /* For configurator pages */
        --configurator-text-color: ${themeTokens.textColor};
        --configurator-border-radius: 0;
        --configurator-divider-color: #00000020;
        --configurator-calculator-pre-summary-border-color: transparent;
        --configurator-calculator-summary-border-color: transparent;

        --configurator-back-color: ${themeTokens.primaryColor};
        --configurator-back-color-hover: ${themeTokens.hoveredPrimaryColor};
        --configurator-back-color-active: ${themeTokens.primaryColor};

        --configurator-widget-active-color: var(--ant-primary-color);
        --configurator-widget-title-font-weight: 900;
        --configurator-widget-background: #eeeff2;
        --configurator-widget-text-color: ${themeTokens.textColor};

        --configurator-widget-popup-background: #eeeff2;
        --configurator-widget-popup-summary-text-color: ${themeTokens.textColor};
        --configurator-widget-popup-text-color: ${themeTokens.textColor};
        --configurator-widget-popup-disabled-text-color: rgb(148, 149, 152);
        --configurator-widget-popup-text-color-opacity: 1;
        --configurator-widget-popup-calculator-background: #00000011;

        --configurator-widget-bar-color: #b5b5b5;
        --configurator-widget-bar-open-color: #b5b5b5;

        --configurator-widget-checked-color: #ffffff;

        --configurator-vehicle-select-height: 82px;
        --configurator-vehicle-select-label-padding-bottom: 0px;
        --configurator-widget-popup-calculator-field-background-color: transparent;

        --configurator-widget-dealer-select-container-height: auto;
        --configurator-widget-dealer-select-container-form-item-display: block;


        .ant-pro-footer-bar {
            padding-top: 8px;
            padding-bottom: 8px;
            padding-right: 60px;
            @media (max-width: ${breakpoints.md}) {
                padding-right: 24px;
            }
        }

        /* For calculator ui */
        --calculator-form-item-error-border: 0;

        --calculator-field-background-color: transparent;
        --calculator-field-label-padding: 0;
        --calculator-field-label-color: rgb(1, 2, 5);
        --calculator-field-disabled-label-color: rgb(148, 149, 152);
        --calculator-field-padding: 0;
        --calculator-grid-item-gap: 16px;
        --calculator-grid-item-min-height: 54px;

        --calculator-comparison-form-item-height-default: 58px;
        --calculator-comparison-form-item-height-second: 86px;
        --calculator-comparison-below-condition-background: #eeeff2;
        --calculator-comparison-form-item-ant-typography-padding-left-right: 0px;
        --calculator-comparison-mobile-form-item-padding-top: 48px;
        --calculator-comparison-mobile-form-item-padding-top-sm: 58px;
        --calculator-comparison-form-item-error-position: static;
        --calculator-comparison-vehicle-image-height: 333px;
        --calculator-comparison-vehicle-image-height-xl: 175px;
        --calculator-comparison-vehicle-image-height-lg: 117px;
        --calculator-comparison-vehicle-image-height-m: 180px;
        --calculator-comparison-vehicle-image-height-sm: 200px;

        --mobility-rental-field-margin-bottom-inner: 24px;

        --vehicle-image-border-radius: 6px;

        --image-selection-border: 2px solid transparent;
        --image-selection-border-radius: 4px;
        --image-selection-active-border-color: #6b6d70;
        --image-selection-outline: 0px;
        --image-selection-outline-offset: 0px;
        --image-selection-active-outline-color: transparent;

        --carousel-images-dots-bottom: 0;
        --carousel-images-dots-gap: clamp(16px, 12px + 1.25vw, 36px);
        --carousel-images-dots-width: 8px;
        --carousel-images-dots-height: 8px;
        --carousel-images-dots-background-color: #6B6D70;
        --carousel-images-dots-border-radius: 4px;
        --carousel-images-dots-opacity: 1;
        --carousel-images-dots-box-shadow: none;
        --carousel-images-dots-active-width: 20px;
        --carousel-images-dots-active-height: 8px;
        --carousel-images-dots-active-background-color: #010205;
        --carousel-images-dots-active-opacity: 1;
        --carousel-images-dots-active-box-shadow: none;

        --card-border-radius: 4px;

        /* since p-modal has z-index of 99999 and tooltip's default z-index is 1070, showing tooltip on the p-modal will not be visible. */
        .ant-tooltip {
            z-index: 100000;
        }
    }
`;

const PorscheGlobalStyles = () => {
    useEffect(() => {
        document.documentElement.classList.add(PORSCHE_V3_THEME_CLASSNAME);

        return () => {
            document.documentElement.classList.remove(PORSCHE_V3_THEME_CLASSNAME);
        };
    }, []);

    return (
        <>
            <NotificationGlobalStyle />
            <FooterGlobalStyle />
            <GlobalThemeToken />
        </>
    );
};

export default PorscheGlobalStyles;
